const authentication = '/authentication/v1'
const authenticationV2 = '/authentication/v2'
const suffix = '/'

const dashboardBase = authentication + '/dashboard'
const dashboard = {
	BASE: dashboardBase,
	AUDIT_LOG: dashboardBase + '/auditLog/module',
	AUDIT_LOG_USER: dashboardBase + '/auditLog/userActivity',
	PARKING: dashboardBase + '/parking',
	CONSUMER: dashboardBase + '/consumer',
	CONSUMER_SEARCH: dashboardBase + '/consumer/search',
	CONSUMER_ADDRESS: dashboardBase + '/consumer/address',
	CONSUMER_RFID: dashboardBase + '/consumer/rfid',
	CONSUMER_UI: dashboardBase + '/consumerUserIdentification',
	PARKING_SESSION: dashboardBase + '/parkingSession',
	COMPANY: dashboardBase + '/company/locationCodes',
	VAS: dashboardBase + '/vas/allocatedData',
	FILTER: dashboardBase + '/filter',
	OFFER: dashboardBase + '/Offer',
	OFFER_PROMO: dashboardBase + '/Offer/Promo',
	OFFER_SUB: dashboardBase + '/Offer/subCorporate',
	ENABLE_VERSION: dashboardBase + '/enableVersionManagement',
	OTP: dashboardBase + '/generateOTP',
	ENABLE_SYSTEM: dashboardBase + '/enableVersionManagement/enableSystem',
	ENABLE_CONFIG: dashboardBase + '/enableConfig',
	REVERSE_PERMISSION: dashboardBase + '/reverse/permission',
	SESSION_LOG: dashboardBase + '/sessionLogs',
	ENABLE_TRANSACTION: dashboardBase + '/enable/transactions',
	ENABLE_EVENTS: dashboardBase + '/enable/events',
	ENABLE_PERMISSION: dashboardBase + '/enable/permission',
	CONSUMER_SESSION: dashboardBase + '/consumerSession/forceClose',
	PERMISSION_MASTER: dashboardBase + '/permissionMaster',
	GRAFANA_DETAILS: dashboardBase + '/grafanaDetails',
	PARKING_SESSION_IMAGE: dashboardBase + '/parkingSessionImage',
	TEMPLATE_TYPES: dashboardBase + '/communication/templates/types',
	COMM_COMPANY: dashboardBase + '/communication/company',
	TENANT: dashboardBase + '/tenant',
}

// Express go-live tooling — served by the parking service directly (this prefix is routed to
// parking at the gateway, so these calls do not pass through the authentication service).
const expressToolBase = authentication + '/tool/express'
const expressTool = {
	BASE: expressToolBase,
	GET_PREAUTH_AMOUNTS: expressToolBase + '/getPreAuthAmounts',
	UPDATE_PREAUTH_AMOUNTS: expressToolBase + '/preAuthAmounts',
	DISPLAY_ASSET_PRESIGNED_URL: expressToolBase + '/displayAsset/presignedUrl',
	DISPLAY_ASSET_LIST: expressToolBase + '/displayAsset/list',
	POS_TERMINAL: expressToolBase + '/posTerminal',
	LANE_CAMERA: expressToolBase + '/laneCamera',
	POS_DEVICE: expressToolBase + '/posDevice',
	LANE_ACTIVITY: expressToolBase + '/laneActivity',
	DEVICE_LOGS: expressToolBase + '/deviceLogs',
	DEVICE_LOGS_DOWNLOAD_URL: expressToolBase + '/deviceLogs/downloadUrl',
	DEVICE_LOGS_GREP: expressToolBase + '/deviceLogs/grep',
	LANE_DEVICE: expressToolBase + '/laneDevice',
	LANE_DEVICE_CONFIG: expressToolBase + '/laneDevice/config',
	LANE_DEVICE_SEARCH: expressToolBase + '/laneDevice/search',
}

const reportBase = authentication + '/report'
const report = {
	BASE: reportBase,
	PARKING_LOG: reportBase + '/parkingLogs',
	SESSION: reportBase + '/session',
	DATA_DUMP: reportBase + '/dataDump',
	LIVE_SESSION: reportBase + '/liveSessionReport',
	// REVENUE: reportBase + '/revenue',
	ANOMALY: reportBase + '/anamoly',
}

const paymentBase = authentication + '/payment'
const payment = {
	TRANS_DETAILS: paymentBase + '/transaction/transactionDetails',
	TRANS_HISTORY: paymentBase + '/transaction/history',
	REFUND: paymentBase + '/refund',
	DOWNLOAD_INVOICE: paymentBase + '/operator/downloadInvoice',
}

const paymentsBase = authentication + '/payments'
const payments = {
	GATEWAY: paymentsBase + '/gateway',
	GATEWAY_ATTRIBUTE: paymentsBase + '/gateway/attribute',
}
const discount = {
	DISCOUNT_CARDS: authentication + '/discountCards/getAllV2',
}

const consumerBase = authentication + '/consumer'
const consumer = {
	BASE: consumerBase,
	VEHICLE: consumerBase + '/vehicle',
	DASHBOARD_SIGNUP: consumerBase + '/dashboard/signUp',
	PAYMENT: consumerBase + '/payment',

	PARKING_SESSION: consumerBase + '/parkingSession',
	PARKING_SESSION_BREAK: consumerBase + '/parkingSession/breakupsById/bulk',
	INDENTIFICATION: consumerBase + '/identification',
	DEVICE: consumerBase + '/device',
	BULK_ON_BOARD: consumerBase + '/corporate/bulkOnBoardFromCsv',
	UPDATE_BULK_ON_BOARD: consumerBase + '/corporate/updateBulkOnBoardFromCsv',
	CORPORATE_LIST: consumerBase + '/corporate/list',
	CORPORATE_LIST_SEARCH: consumerBase + '/corporate/list/search',
	BULK_ENABLED: consumerBase + '/corporate/bulkEnableCorporateAccounts',
	BULK_DISABLED: consumerBase + '/corporate/bulkDisableCorporateAccounts',
	BULK_LINK: consumerBase + '/corporate/bulkLinkCorporateAccounts',
	BULK_DELINK: consumerBase + '/corporate/bulkDelinkCorporateAccounts',
	CORPORATE_USER: consumerBase + '/corporate/createCorporateUser',
	UPDATE_CORPORATE_USER: consumerBase + '/corporate/updateCorporateUser',
	ON_BOARD_SINGLE_USER: consumerBase + '/corporate/onBoardSingleUser',
	VERIFY_RFID: consumerBase + '/rfidOrder/verifyRfid',
	LINK_RFID: consumerBase + '/rfidOrder/linkRfid',
	DELINK_RFID: consumerBase + '/rfidOrder/deLinkRfid',
	PARKING_SESSION_COUNT: consumerBase + '/parkingSession/sessionCount',
}

const consumersBase = authentication + '/consumers'
const consumers = {
	BASE: consumersBase,
	ACCOUNT_GROUPS: consumersBase + '/accountGroups',
	GROUP_ID: consumersBase + '/accountGroups/byGroupId',
	ADD_GROUPS: consumersBase + '/accountGroups/addAccountGroup',
	GROUP_ACCOUNT: consumersBase + '/accountGroups/groupAccount',
	DOCUMENTS: consumersBase + '/documents',
	FORWARD_QR_RESET: accountId => authenticationV2 + `/consumers/forwardQr/reset/${accountId}`,
}

const passBase = authentication + '/pass'
const pass = {
	BASE: passBase,
	PASS_ALLOCATIONS: passBase + '/dashboard/passAllocations',
	PASS_ALLOCATE: passBase + '/passAllocate',
	PASS_MASTER: passBase + '/passMaster',
	PASS_MASTER_ACCESS: passBase + '/passMasterAccess',
	CORPORATE_PASS_ALLOCATE: passBase + '/corporate/passAllocate',
	PASS_ACTIVITY: passBase + '/passAllocation/activity',
}
const parkingBase = authentication + '/parking'
const parking = {
	BASE: parkingBase,
	ACCESS_METHODS: parkingBase + '/accessMethods',
	HARDWARE_MASTER: parkingBase + '/hardwareMaster',
	DEVICE_DETAILS: parkingBase + '/deviceDetails',
	PARKING_IMG: parkingBase + '/parkingImages',
	UPDATE_IMG: parkingBase + '/bulkUpdateParkingImages',
	UPLOAD_IMG: parkingBase + '/bulkUploadParkingImages',
	ACCESS_TYPE_MASTER: parkingBase + '/accessTypeMaster/list',
}

const tariffBase = authentication + '/tariff'
const tariff = {
	BASE: tariffBase,
	LIST: tariffBase + '/list',
	CALCULATE: tariffBase + '/calculate',
	DATE_BY_ID: tariffBase + '/dataByIds',
	TEST_TARIFF: tariffBase + '/testTariff',
	TARIFF_AUTOMATIOM: tariffBase + '/testTariff/automation',
	FETCH_LIVERATE: tariffBase + '/fetchTariffRates'
}

const promotionBase = authentication + '/promotion'
const promotion = {
	BASE: promotionBase,
	OFFER_BY_ID: promotionBase + '/byOfferId',
	CREATE: promotionBase + '/create',
	BULD_CREATE: promotionBase + '/bulk/create',
	BULK_UPLOAD: promotionBase + '/bulkUpload/csv',
	EXPIRE: promotionBase + '/expire',
	AUTO_GENERATE_AND_DELIVER: promotionBase + '/auto-generate-and-deliver',
	QR_JOBS: promotionBase + '/qr-jobs',
	QR_JOB: jobId => promotionBase + `/qr-jobs/${jobId}`,
	QR_JOB_EVENTS: jobId => promotionBase + `/qr-jobs/${jobId}/events`,
	QR_JOB_PROMOTIONS: jobId => promotionBase + `/qr-jobs/${jobId}/promotions`,
	QR_JOB_EXPIRE: jobId => promotionBase + `/qr-jobs/${jobId}/expire`,
	QR_JOB_RESEND_EMAIL: jobId => promotionBase + `/qr-jobs/${jobId}/resend-email`,
	QR_JOB_RETRY_DELIVERY: jobId => promotionBase + `/qr-jobs/${jobId}/retry-delivery`,
}

const operatorBase = authentication + '/operator'
const operator = {
	BASE: operatorBase,
	LOGIN: operatorBase + '/login',
	LOGOUT: operatorBase + '/logout',
	SIGNUP: operatorBase + '/signUp',
	LIST: operatorBase + '/list',
	ACCESS: operatorBase + '/access',
	PERMISSION: operatorBase + '/permission',
	CHANGE_PASSWORD: operatorBase + '/changePassword',
}

const monitorBase = authentication + '/monitor'
const monitor = {
	BASE: monitorBase,
	ALERT_CONFIG: monitorBase + '/alertConfiguration',
	ALERT_PREFERNCES: monitorBase + '/alertPreferences',
}

const sponsoredAdsBase = dashboardBase + '/inAppSponsorAds'
const sponsoredAds = {
	BASE: sponsoredAdsBase,
	FETCHPROMO: sponsoredAdsBase + '/getInAppSponsorAdsDetails',
	CREATEPROMO: sponsoredAdsBase + '/createInAppSponsorAds',
	UPDATEPROMO: sponsoredAdsBase + '/updateInAppSponsorAds',
	PRESIGNEDURL: sponsoredAdsBase + '/getPreSignedUploadImageUrl',
}
const validateOnlinePayment = authentication + '/gmp-billing/core'

const eventBase = authentication + '/event'
const event = {
	BASE: eventBase,
	ADD_TARIFF: eventBase + '/add-tariff',
	UPDATE_TARIFF: eventBase + '/update-tariff',
}

const tariffEngineBase = '/v1/tariff'
const tariffEngine = {
	BASE: tariffEngineBase,
	HAND_HELD: tariffEngineBase + '/hand-held',
}

export default {
	BASE: authentication,
	LOGIN: authentication + '/operator/login' + suffix,
	GRAPHQL_OPERATOR: authentication + '/permit/graphql/operator' + suffix,
	MASTER_CONFIG: authentication + '/company/companyAttribute',
	BULK_UPLOAD: authentication + '/permit/migration/bulkAllocationFromCSV',
	DASHBOARD: dashboard,
	REPORT: report,
	PAYMENT: payment,
	PAYMENTS: payments,
	CONSUMER: consumer,
	DISCOUNT: discount,
	CONSUMERS: consumers,
	PASS: pass,
	PARKING: parking,
	SEARCH: authentication + '/search',
	CORPORATE: authentication + '/corporate',
	PARKING_LOT: authentication + '/parkingLot',
	TARIFF: tariff,
	PROMOTION: promotion,
	LANES: authentication + '/lanes',
	OPERATOR: operator,
	VALUE_ADDRESS_SERVICE: authentication + '/valueAddedServices',
	GATE_CONTROLLER: authentication + '/gateController',
	SUB_CORPORATE: authentication + '/subCorporate',
	MONITOR: monitor,
	COMPANY: authentication + '/company',
	COMPANY_ATTRIBUTE: authentication + '/company/companyAttribute',
	RECEIPT_CONTENT: authentication + '/receiptContent',
	VALIDATE_ONLINE_PAYMENT: validateOnlinePayment + '/validateOnlinePayment',
	BILLING_PAYMENT: validateOnlinePayment + '/makeBillingPayment',
	SPONSORED_ADS: sponsoredAds,
	REDIRECT_URL: authentication + '/consumer/payment/operator/redirectUrl',
	DUPLICATE_VALIDATION: authentication + '/permit/allocation/validateMatch',
	REVERT_PERMIT_PRICE: authentication + '/permit/permit-master/revert/permitMasterPricing',
	REVERT_PASS_PRICE: authentication + '/pass/passMaster/revert/passMasterPricing',
	REVERT_PERMIT_PRICE_ALLOCATION_DETAILS: authentication + '/permit/permit-allocation/getPriceUpdateEffectedAllocationDetails',
	REVERT_PASS_PRICE_ALLOCATION_DETAILS: authentication + '/pass/allocation/getPriceUpdateEffectedAllocationDetails',
	UPDATE_TTO: authentication + '/parking/updateTTO',
	LINK_LANES: authentication + '/lanePair',
	PRORATION_API:   '/authentication/v2/permit/prorated-cost/',
	PERMIT_ALLOCATION: '/authentication/v2/permitAllocation/purchase/operator',
	FETCH_PARKING_LOT:'/authentication/v2/permit/',
	SET_PERMIT_CAPACITY:'/authentication/v1/permitPurchaseCapacity/setPermitCapacity',
	UPDATE_PERMIT_CAPACITY:'/authentication/v1/permitPurchaseCapacity/updateCapacity/',
	DELETE_PERMIT_CAPACITY:'/authentication/v1/permitPurchaseCapacity/deleteRule/',
	PASS_MASTER_ALLOCATION_REQUEST: authenticationV2+'/permitAllocation/list',
    PERMIT_ALLOCATION_UPDATE_REQUEST: authenticationV2+'/permitAllocation/update',
	PERMIT_ALLOCATION_RETRY_PAYMENT_REQUEST:authenticationV2+'/permitAllocation/retry-payment',
	PERMIT_ALLOCATION_BY_ID:authenticationV2+'/permit/id',
	PASS_MASTER_ALLOCATION_USAGE_HISTORY_REQUEST: authenticationV2+'/permitAllocation/usage/history',
	PAYMENT_GATEWAY: authentication+ '/payments/gateway',
	TARIFF_DETAILS_BY_PERMIT_MASTER: authenticationV2 + '/tariff/reservation/list',
	REVERT_RESERVATION_TARIFF_PRICE: (id) => authenticationV2 + `/tariff/reservation/revert/${id}`,
	CREATE_TARIFF_BASED_RESERVATION: authenticationV2 + '/reservation/createReservation',
	PERMIT_CAPACITY: authenticationV2+ '/permit/capacity/id',
	GET_ACTIVE_TARIFF_RESERVATION: authenticationV2 + '/reservation/activeTariffReservation',
	EVENT: event,
	EXPRESS_TOOL: expressTool,
	TARIFF_ENGINE: tariffEngine,
	GET_ACCOUNT_AUDIT_LOG_HISTORY: (accountId) => authenticationV2 + `/consumer/audit/getAccountAuditLogHistory/${accountId}/contactDetails`,
	VALIDATE_CONSUMER_CONTACT_DETAILS_UNIQUENESS: (accountId) => authenticationV2 + `/consumers/${accountId}/contact-details/validate-uniqueness`,
	UPDATE_CONSUMER_CONTACT_DETAILS: (accountId) => authenticationV2 + `/consumers/${accountId}/contact-details`,
	CONSUMER_ACCOUNT_CHANGE_REQUEST_PENDING: authentication + '/consumers/accountChangeRequest/pending',
	CONSUMER_ACCOUNT_CHANGE_REQUEST_REVERT: authentication + '/consumers/accountChangeRequest/revert',

}

// 723034